define('instrumentation/console-listener', ['lib/underscore', 'instrumentation/log-category'], function (_, LOGCATEGORY) {
    return function (options) {
        var listener = this;

        _.extend(listener, {
            flushLogs: _.noop,
            write: function (logMessage) {
                var msg;
                if (listener.shouldLog(logMessage)) {
                    msg = format(logMessage);

                    if (isErrorLog(logMessage)) {
                        window.console.error(msg);
                    } else {
                        window.console.log(msg);
                    }
                }
            },
        });

        if (window.BINGADS_DEBUG !== true) {
            listener.shouldLog = isErrorLog;
        } else {
            listener.shouldLog = _.constant(true);
        }

        function isErrorLog(logMessage) {
            return _.contains(logMessage.logCategory, LOGCATEGORY.ERROR) ||
                logMessage.logCategory === LOGCATEGORY.ERROR;
        }

        function format(logMessage) {
            return '[' + logMessage.logLevel.name.toUpperCase() + '] [' +
                _.uniqueId() + '] [' +
                (_.isArray(logMessage.logCategory) ? logMessage.logCategory.join(',') : logMessage.logCategory) + '] {' +
                _.compact([
                    logMessage.logId,
                    logMessage.scenarioName,
                    'requestId: ' + logMessage.requestId,
                    logMessage.api + ': ' + logMessage.message,
                    logMessage.timeTaken ? 'Dur: '+ logMessage.timeTaken : '',
                ]).join(', ') +
                ' }';
        }
    };
});
